import { AdPackageConfig } from "@/sell/models/checkout/config/AdPackageConfig";
import { AdPackageStatus } from "@/sell/models/checkout/state/AdPackageState";

export const CheckoutPackageService = {
  GetStatusForPackage: function ({
    product,
    pastPackage,
    pendingPackage,
  }: {
    product: AdPackageConfig;
    pastPackage?: AdPackageConfig;
    pendingPackage?: AdPackageConfig;
  }): AdPackageStatus {
    if (pastPackage && pastPackage.value >= product.value) {
      return "UNAVAILABLE_PURCHASED";
    } else if (pendingPackage && pendingPackage.value === product.value) {
      return "ADDED";
    } else if (pendingPackage && pendingPackage.value > product.value) {
      return "INCLUDED";
    } else if (!pastPackage || pastPackage.value < product.value) {
      return "AVAILABLE";
    } else {
      return "INVALID";
    }
  },
};
